import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const state = {
  rivers: [],
};

const getters = {
  getRivers: (state) => state.rivers,
};

const actions = {
  async get_rivers({ commit }) {
    const resp = await asyncHandler(HTTP({ url: "river/all", method: "GET" }));
    if (resp.success) {
      commit("set_rivers", resp.rivers);
    }
    return resp;
  },
};

const mutations = {
  set_rivers: (state, rivers) => {
    state.rivers = rivers;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
